import { render, staticRenderFns } from "./SettingsRootView.vue?vue&type=template&id=1ba56378"
import script from "./SettingsRootView.vue?vue&type=script&lang=js"
export * from "./SettingsRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports